import { createApi } from '@reduxjs/toolkit/query/react'
import { createNeighborhoodAwareBaseQuery } from '../../../Utils/baseQuery'

export const categoryApiService = createApi({
  reducerPath: 'categoryApi',
  baseQuery: createNeighborhoodAwareBaseQuery('/category/'),
  endpoints: (builder) => ({
    getCategories: builder.query({
      query: (args) => ({
        url: args?.id ? `get/${args?.id}` : "get",
        method: "GET",
        params: args?.id ? {} : args
      }),
      keepUnusedDataFor: 0
    }),
    getCategoryById: builder.query({
      query: (args) => `get/${args.id}`,
      keepUnusedDataFor: 0
    }),
    addCategory: builder.mutation({
      query: (payload) => ({
        url: 'create',
        method: 'POST',
        body: payload
      })
    }),
    updateCategory: builder.mutation({
      query: (args) => {

        let { id, payload } = args
        let url = `update/${id}`

        if (!id) {
          url = 'update'
        }

        return ({
          url,
          method: 'PUT',
          body: payload
        })

      }
    }),
    deleteCategory: builder.mutation({
      query: (payload) => ({
        url: `delete/${payload.id}`,
        method: 'DELETE'
      })
    }),
  })
})

export const {
  useGetCategoriesQuery,
  useGetCategoryByIdQuery,
  useAddCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation
} = categoryApiService